import { defineMessages, useIntl } from 'react-intl';
import {
  RichText,
  richTextHasContent,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import { renderPDCItemValue } from 'design-comuni-plone-theme/helpers';

const messages = defineMessages({
  folder_address: {
    id: 'booking_folder_address',
    defaultMessage: 'Indirizzo',
  },
  folder_opening: {
    id: 'booking_folder_opening',
    defaultMessage: 'Apertura',
  },
  folder_description: {
    id: 'booking_folder_description',
    defaultMessage: 'Descrizione',
  },
});

const PrenotazioneCardIndirizzoOrario = ({ folder, address, contacts }) => {
  const intl = useIntl();

  return (
    <>
      {address && (address.street || address.city) && (
        <p className="p-info">
          {intl.formatMessage(messages.folder_address)}
          <span className="d-block fw-semibold">
            {[address.street, address.city]
              .filter((v) => v !== null)
              .join(' - ')}
            {(address.street || address.city) &&
              address.zip_code &&
              ', ' + address.zip_code}
          </span>
        </p>
      )}

      {/* INFO ORARIO DI APERTURA */}
      {folder && folder.orario_di_apertura && (
        <p className="p-info">
          {intl.formatMessage(messages.folder_opening)}
          <span className="d-block fw-semibold">
            {folder.orario_di_apertura}
          </span>
        </p>
      )}

      {/* DESCRIZIONE AGENDA */}
      {folder && richTextHasContent(folder.description_agenda) && (
        <p className="p-info">
          {intl.formatMessage(messages.folder_description)}
          <RichText serif={false} data={folder.description_agenda} />
        </p>
      )}

      {contacts &&
        contacts.map(
          (contact) =>
            contact?.value_punto_contatto.map((pdc, index) => (
              <>
                <span key={index}>{renderPDCItemValue(pdc, intl)}</span>
                <br />
              </>
            )) ?? null,
        )}
    </>
  );
};

export default PrenotazioneCardIndirizzoOrario;
